import { LNGS_NAMESPACE_LOGICAL_DEVICE } from '@ingenico/util-i18n-config';
import { isEmpty, toString } from 'lodash-es';
import type { ReactNode } from 'react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FileOutputFormularyModalSchemaKeys } from '../../useFileOutputFormularyModal.hook';
import { SelectorField } from '../SelectorField/SelectorField.ctrl';
import type { FieldsProps } from '../fieldsModel.model';

export function ModuleField({ form, options, isLoading, onFilterChange }: FieldsProps): ReactNode {
  const { t } = useTranslation(Object.values(LNGS_NAMESPACE_LOGICAL_DEVICE));

  const { watch, control } = form;

  const [versionId, moduleIdField] = watch([
    FileOutputFormularyModalSchemaKeys.VersionIdField,
    FileOutputFormularyModalSchemaKeys.ModuleIdField,
  ]);

  const optionsIds = useMemo(() => {
    return options?.map(({ id }) => id) ?? [];
  }, [options]);

  const findOptionName = useCallback(
    (targetId: string) => {
      return options?.find(({ id }) => targetId === id)?.label ?? '';
    },
    [options],
  );

  const handleInputChange = useCallback(
    (evt: unknown, value: string, reason?: string) => {
      if (reason === 'clear' || reason === 'input') {
        onFilterChange(value);
      }
    },
    [onFilterChange],
  );

  const inputTextValue = useMemo(
    () => toString(options?.find((option) => option.id === moduleIdField)),
    [options, moduleIdField],
  );

  return (
    <SelectorField
      control={control}
      dataErrorTestId={'module-error-field-data-id'}
      dataTestId={'module-field-data-id'}
      fieldName={'moduleId'}
      getOptionLabel={(field) => findOptionName(field)}
      inputLabel={t('fileOutputModal.fields.module')}
      isDisabled={isEmpty(versionId)}
      isLoading={isLoading}
      isReadOnly={isEmpty(versionId)}
      options={optionsIds}
      onInputChange={handleInputChange}
      inputValue={inputTextValue}
    />
  );
}
